var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdriveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 139.89 184.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#0b74b8;}.cls-4{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-0.47 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 141,
    height: 184.71
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.3,80.5a13.92,13.92,0,0,0-1.5-2.39A37.5,37.5,0,0,0,117.3,66.2a33.7,33.7,0,0,0-10-4.09L62.3,50A42.24,42.24,0,0,0,52,48.61,37.47,37.47,0,0,0,32.3,54a9.39,9.39,0,0,0-1.7,1.11A37.75,37.75,0,0,0,14,77.9l-12.1,45a38.18,38.18,0,0,0,3.9,29.9,37.54,37.54,0,0,0,24,18.4l45.1,12.1a38,38,0,0,0,29.8-4,38.14,38.14,0,0,0,18.5-23.8l12.1-45a38.16,38.16,0,0,0-2.7-27.6A13.57,13.57,0,0,0,131.3,80.5Zm1.5-53.1A52.38,52.38,0,0,0,99.6,2,53,53,0,0,0,58.1,7.4,53.11,53.11,0,0,0,32.7,40.7c-.6,2.3-1.1,4.5-1.5,6.7,7.8-4,15.4-5.79,22.9-5.5a32.93,32.93,0,0,1,14.2-16,33.29,33.29,0,0,1,25.8-3.4,32.63,32.63,0,0,1,20.6,15.8,33.32,33.32,0,0,1,4.4,20.81c6.2,3.39,11.9,9.09,17,16.79a68.67,68.67,0,0,0,2.4-6.79c3.7-14.61,1.9-28.61-5.7-41.71",
    transform: "translate(-0.47 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.4,108.1H85.8c-.5-5.7-2-10-4.7-12.8-2.9-3-7.1-4.5-12.5-4.5a16.78,16.78,0,0,0-12.1,4.5c-3.2,3.1-4.9,7.3-5.1,12.8M91.9,133h16.9c-2.5,8.9-7.2,15.7-14.2,20.4-7,4.9-15.7,7.3-26.3,7.3-12.8,0-22.8-3.9-30-11.8-7.2-7.7-10.8-18.6-10.8-32.9,0-13.6,3.5-24.2,10.5-31.89C45.2,76.2,55.2,72.3,68,72.3c13.5,0,24,3.81,31.4,11.5,7.2,7.9,10.8,18.8,10.8,32.9v3.5a5.39,5.39,0,0,1-.3,2.2H51.5q.3,9.9,5.1,14.7,4.35,5.1,13.2,5.1a20,20,0,0,0,9.8-2.2,5.24,5.24,0,0,0,1.9-1.1c.6-.5,1.2-1.1,1.9-1.8a7.06,7.06,0,0,1,2.5-2.5c1.2-1,3.3-1.6,6-1.6",
    transform: "translate(-0.47 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdriveIcon);
export default __webpack_public_path__ + "static/media/idrive-icon.a6471cfba6e9bd0aed4f42bb6f69b7fc.svg";
export { ForwardRef as ReactComponent };